<template>
  <div class="outDiv noShadow" v-loading="isLoading">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover placement="right-bottom" title="条件检索" trigger="click" v-model="searchVisible">
          <searchForm
            @startSearch="handleTableSearch"
            @cancleSearch="handleCancleSeach"
            @showSearchForm="showSearchForm"
          ></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag :searchTagList="searchTagList" @handleDelOne="handleDelOne"></navTopTag>
      </div>
    </div>
    <div>
      <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane label="所有数据" name="all" ref="all" id="allTab"></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs>
      <div class="tableContainer">
        <baseTable
          :columns="allTableObj.columns"
          :dataList="allTableObj.dataList"
          :options="allTableObj.options"
          :loadObj="allTableObj.loadObj"
          :operationColumn="allTableObj.operationColumn"
          :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event,allTableObj)"
          @dataCurrentChange="handleCurrentChange($event,allTableObj)"
        ></baseTable>
      </div>
    </div>
    <el-dialog center title="订单详情" :visible.sync="showDetailDialog" :append-to-body="true">
      <el-form size="mini" labelWidth="150px" labelPosition="right">
        <el-form-item label="评价时间">
          <span>{{detailObj.createTime}}</span>
        </el-form-item>
        <el-form-item label="订单编号">
          <span>{{detailObj.orderGid}}</span>
        </el-form-item>
        <el-form-item label="服务项目">
          <span>{{detailObj.project}}</span>
        </el-form-item>
        <el-form-item label="服务人员">
          <span>{{detailObj.staff}}</span>
        </el-form-item>
        <el-form-item label="评价得分">
          <span>{{detailObj.evalScore}}</span>
        </el-form-item>
        <el-form-item label="评价内容">
          <span>{{detailObj.evalContent}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "./_component/search-form";
import { request } from "https";
import { getOlderList, delOneOrg, getProviderEval } from "@/services/all-api.js";
import { mapState } from "vuex";

export default {
  components: {
    searchForm
  },
  computed: {
    ...mapState(["oneOlder"])
  },
  data() {
    return {
      detailObj: {
        createTime: "",

      },
      showDetailDialog: false,
      isLoading: false,
      searchTagList: [],
      searchVisible: false,
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "60px",
            align: "center"
          },
          {
            prop: "createTime",
            label: "评价时间",
            align: "center"
          },
          {
            prop: "orderGid",
            label: "订单编号",
            align: "center"
          },
          {
            prop: "project",
            label: "服务项目",
            align: "center"
          },
          {
            prop: "staff",
            label: "服务人员",
            align: "center",
            width: "200px"
          },
          {
            prop: "evalScore",
            label: "评价得分",
            align: "center",
            width: "200px"
          },
          {
            prop: "evalContent",
            label: "评价内容",
            align: "center",
            width: "200px"
          }
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              disabled: false,
              style: "font-size:16px",
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            }
          ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    };
  },
  methods: {
    showSearchForm() {
      this.searchVisible = true;
    },
    listTrans(obj) {
      const result = {
        data: obj.data.map((item, i) => ({
          num: obj.index * obj.size + i + 1,
          gid: item.gid,
          orderGid: item.orderGid,
          theOldGid: item.theOldGid,
          project: item.serviceItemname,
          staff: item.servicePersonalName,
          evalScore: item.scoreFromTheOld,
          createTime: item.timeByTheOld,
          orderNum: item.address,
          evalContent: item.contentFromTheOld,
          contantsName: item.contantsName
        })),
        total: obj.total,
        index: obj.index,
        size: obj.size
      };
      return result;
    },
    firstGet(obj) {
      this.isLoading = true;
      const reqObj = {
        index: 0,
        size: 20,
        theoldgid: this.oneOlder.theOldGid
      };
      getProviderEval(reqObj).then(res => {
        this.isLoading = false;
        const result = this.listTrans(res.data);
        obj.dataList = result.data;
        obj.fenyeObj.total = result.total;
        obj.fenyeObj.currentPage = result.index + 1;
        obj.fenyeObj.pageSize = result.size;
      });
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getTagList(
        this.getEvalSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        type: 1,
        ...i.searchData,
        startTime: !i.searchData.timeRange ? "" : i.searchData.timeRange[0],
        endTime: !i.searchData.timeRange ? "" : i.searchData.timeRange[1]
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          type: 1,
          ...obj,
          startTime: !obj.timeRange ? "" : obj.timeRange[0],
          endTime: !obj.timeRange ? "" : obj.timeRange[1]
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    tabClick(i) {
      if (i.name == "all") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "search") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.searchDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.searchDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.searchDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.searchDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
    },
    //检索条件或者分页等变化时请求数据
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      getProviderEval({ ...reqobj, theOldGid: this.oneOlder.theOldGid })
        .then(res => {
          let endData = this.listTrans(res.data)
          if (flag == "all") {
            obj.allDataNow.dataList = endData.data;
            obj.allDataNow.total = endData.total;
            obj.fenyeObj.currentPage = endData.currentPage;
            obj.fenyeObj.pageSize = endData.pageSize;
            obj.dataList = obj.allDataNow.dataList;
            obj.fenyeObj.total = obj.allDataNow.total;
            return false;
          } else if (flag == "search") {
            obj.searchDataNow.dataList = endData.data;
            obj.searchDataNow.total = endData.total;
            obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
            obj.dataList = obj.searchDataNow.dataList;
            obj.fenyeObj.total = obj.searchDataNow.total;
            return false;
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 1,
        };
      } else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 1,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize,
          type: 1,
          theoldgid: this.oneOlder.theOldGid
        };
      } else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          type: 1,
          theoldgid: this.oneOlder.theOldGid,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleDetail(i, j) {
      this.showDetailDialog = true;
      this.detailObj = { ...j }
    }
  },
  mounted() {
    this.firstGet(this.allTableObj);
  }
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.noShadow {
  box-shadow: 0 0 0 0;
  border: 0;
  padding: 20px 0px;
}
.tableContainer {
  height: calc(100vh - 380px);
}
.tableContainer > div {
  height: 90%;
}
</style>

